import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const ErrorMessage = (props) => {

  let message = 'Something went wrong.'

  if ( props.type === 'no-results' ) {
    message = 'No results found.'
  } else if ( props.type === 'posts-error' ) {
    message = 'Something went wrong. Try refreshing the page.'
  }

  return (
      <div className="c-projects__error">
      <p>{message}</p>
      </div>
)

}

export default ErrorMessage



// WEBPACK FOOTER //
// ./src/js/recent-news/components/ErrorMessage.js